import "../../css/GlobalStyles.css";
import { ReactNode, memo } from "react";
import CreatorModeWrapper from "../CreatorDashboard/CreatorModeWrapper";
import { Helmet } from "react-helmet";
import { LightTheme, ThemeStyle } from "../../hooks/useTheme";
import { ContainerButton } from "../Buttons/ContainerButton";
import { Colors } from "../../utils/colors";

type FullScreenContainerProps = {
  children: ReactNode;
  title: string;
  helmetTitle: string;
  backOnPress: () => void;
  alternateLeftIcon?: string;
  rightHeaderComp: ReactNode;
  theme?: ThemeStyle;
};

const FullScreenContainer = (props: FullScreenContainerProps) => {
  const {
    children,
    title,
    helmetTitle,
    alternateLeftIcon,
    backOnPress,
    rightHeaderComp,
    theme,
  } = props;

  return (
    <div>
      <Helmet>
        <title>{helmetTitle}</title>
        <meta name="og:title" content={helmetTitle} />
        <meta name="og:description" content={helmetTitle} />
      </Helmet>
      <CreatorModeWrapper hideSidebar>
        <div
          className="ColumnNormal"
          style={{
            padding: 30,
            gap: 30,
            flex: 1,
            transition: "0.3s",
            backgroundColor: theme
              ? theme.SubComponentBG.backgroundColor
              : Colors.WHITE,
          }}
        >
          <div className="AlignedRowSpaced">
            <div className="AlignedRow" style={{ gap: 20 }}>
              <ContainerButton
                onPress={backOnPress}
                theme={theme ?? LightTheme}
                iconName={alternateLeftIcon}
              />
              <span
                style={{ fontWeight: 500, fontSize: 32, ...theme?.PrimaryText }}
              >
                {title}
              </span>
            </div>
            {rightHeaderComp}
          </div>
          {children}
        </div>
      </CreatorModeWrapper>
    </div>
  );
};

export default memo(FullScreenContainer);
